import { NgModule } from '@angular/core';

import { AuthCardComponent } from './components/auth-card/auth-card.component';
import { BasicContentComponent } from './components/basic-content/basic-content.component';
import { BasicFooterComponent } from './components/basic-footer/basic-footer.component';
import { BasicHeaderComponent } from './components/basic-header/basic-header.component';
import { BasicPageComponent } from './components/basic-page/basic-page.component';
import { ContentWithImageComponent } from './components/content-with-image/content-with-image.component';
import { ContentWithLabelComponent } from './components/content-with-label/content-with-label.component';
import { ContextualHeaderComponent } from './components/contextual-header/contextual-header.component';
import { ContextualToolbarComponent } from './components/contextual-toolbar/contextual-toolbar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PanelComponent } from './components/panel/panel.component';
import { PanelContentComponent } from './components/panel-content/panel-content.component';
import { PanelFooterComponent } from './components/panel-footer/panel-footer.component';
import { PanelHeaderComponent } from './components/panel-header/panel-header.component';
import { SectionComponent } from './components/section/section.component';

@NgModule({
  imports: [
    AuthCardComponent,
    ContentWithImageComponent,
    ContentWithLabelComponent,
    ContextualHeaderComponent,
    ContextualToolbarComponent,
    LoaderComponent,
    PanelComponent,
    PanelHeaderComponent,
    PanelContentComponent,
    PanelFooterComponent,
    SectionComponent,
    BasicPageComponent,
    BasicHeaderComponent,
    BasicContentComponent,
    BasicFooterComponent,
  ],
  exports: [
    AuthCardComponent,
    ContentWithImageComponent,
    ContentWithLabelComponent,
    ContextualHeaderComponent,
    ContextualToolbarComponent,
    LoaderComponent,
    PanelComponent,
    PanelHeaderComponent,
    PanelContentComponent,
    PanelFooterComponent,
    SectionComponent,
    BasicHeaderComponent,
    BasicContentComponent,
    BasicFooterComponent,
    BasicPageComponent,
  ],
})
export class SharedLayoutModule {}
